import React, { Component } from "react";

import StoreOverallForm from "./form";

import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";

import { Page, Navbar, Block, BlockTitle } from "framework7-react";

// Helpers
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";
import { connect } from "react-redux";
import { getStoreOverall, updateStoreOverall } from "../actions";

function mapStateToProps(state, ownProps) {
  const {
    f7route: {
      params: { id },
    },
  } = ownProps;

  return {
    current_user: state.current_user,
    store_overall: state.store_overalls[id],
  };
}

class EditStoreOveralls extends Component {
  constructor(props) {
    super(props);

    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    const updateRole = HasRole(
      {
        resource_type: "Project::Qa::ActionItem",
        name: ["update", "moderator"],
      },
      true
    );

    const { id } = this.props;

    if (updateRole) {
      this.props.getStoreOverall(id);
    }

    const returnUrl = `/store/overalls`;

    this.state = {
      returnUrl: returnUrl,
      updateRole,
    };
  }

  submitForm(values) {
    const {
      f7router: { app },
      id,
    } = this.props;

    // When clicked cancel
    this.preloader = app.preloader;
    this.preloader.show();
    const updateRequest = this.props.updateStoreOverall(id, values);
    updateRequest.then(this.successfullySubmitted);
  }

  successfullySubmitted() {
    const {
      f7router,
      f7router: { app },
    } = this.props;

    const { returnUrl } = this.state;

    this.preloader.hide();
    app.toast
      .create({
        icon: '<i class="material-icons">check</i>',
        text: "Updated Store Overall!",
        position: "center",
        closeTimeout: 2000,
        on: {
          opened: () => {
            f7router.navigate(returnUrl);
          },
        },
      })
      .open();
  }

  render() {
    const { store_overall, history } = this.props;
    const { returnUrl, updateRole } = this.state;
    if (!updateRole) {
      return <NotAuthorized />;
    }
    return (
      <Page>
        <Navbar title="Update Store Overall" backLink />
        {_.isNotEmpty(store_overall) && (
          <Form
            component={StoreOverallForm}
            onSubmit={this.submitForm}
            formLabel="Update"
            mutators={{
              ...arrayMutators,
            }}
            initialValues={store_overall}
            cancelFunction={() => {
              history.push(returnUrl);
            }}
            {...this.props}
          />
        )}
        <hr />
        <BlockTitle>Movements</BlockTitle>
        <Block>
          <table className="data-table">
            <thead>
              <tr>
                <th className="label-cell">Date/Time</th>
                <th className="label-cell">Employee</th>
                <th className="label-cell">Status</th>
              </tr>
            </thead>
            <tbody>
              {_.map(store_overall?.movements, (movement, i) => (
                <tr key={i}>
                  <td className="label-cell">{moment(movement.created_at).format("DD/MM/YYYY H:mm")}</td>
                  <td className="label-cell">{movement.employee_name}</td>
                  <td className="label-cell">{movement.status_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Block>
      </Page>
    );
  }
}

export default connect(mapStateToProps, {
  getStoreOverall,
  updateStoreOverall,
})(EditStoreOveralls);
